/**
 * Token storage helpers.
 *
 * We keep the JWT in `localStorage` under a fixed key. On app boot
 * the axios interceptor picks it up and stamps every /api request
 * with `Authorization: Bearer …`. On 401 we clear it and bounce to
 * /login.
 *
 * localStorage is acceptable here because the admin panel is:
 * - served over HTTPS only (Caddy in prod),
 * - behind auth, with CSP and no third-party scripts,
 * - single-user (so no cross-user leakage risk).
 */

const TOKEN_KEY = "cerodeuda.admin.token";

export function getToken(): string | null {
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setToken(token: string): void {
  try {
    window.localStorage.setItem(TOKEN_KEY, token);
  } catch {
    /* storage disabled — ignore */
  }
}

export function clearToken(): void {
  try {
    window.localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
}

export function isAuthenticated(): boolean {
  return getToken() !== null;
}
